// components
import useFetch from "../hook/useFetch";
import { FiAlertTriangle } from "react-icons/fi";
import ProductSlider from "./ProductSlider";
import ProductGridSkeleton from "./ui/ProductGridSkeleton";
import StateMessage from "./ui/StateMessage";

export default function RelatedProducts({ categoryTitle }) {
  // get products by category title
  const { data, isLoading, error } = useFetch(
    `/products/products/${categoryTitle}`
  );

  // hide the whole section when there are no related products
  if (!isLoading && !error && (data?.relatedProducts?.length ?? 0) === 0) {
    return null;
  }

  return (
    <div className="mb-16">
      <div className="container mx-auto">
        <h2 className="h2 mb-6 text-center xl:text-left">Related Products</h2>
        {isLoading ? (
          <ProductGridSkeleton count={4} />
        ) : error ? (
          <StateMessage
            icon={FiAlertTriangle}
            title="Couldn't load related products"
            message="Please try again later."
          />
        ) : (
          <ProductSlider data={data} relatedLabel={true} latestLabel={false} />
        )}
      </div>
    </div>
  );
}
